import React from "react"
import { createRoot } from "react-dom/client"

import { BrowserRouter as Router } from "react-router-dom"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"

import App from "@/app/App"
import { AppThemeProvider } from "@/shared/context/ThemeContext"
import { SnackbarProvider } from "@/shared/context/SnackbarContext"
import { AuthProvider } from "@/features/auth/context/AuthContext"
import ErrorBoundary from "@/shared/components/ErrorBoundary"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"

const rootElement = document.getElementById("root")
const root = createRoot(rootElement!)

root.render(
  <GoogleReCaptchaProvider
    reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY!}
    scriptProps={{ async: true, defer: true }}>
    <AppThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <ErrorBoundary>
          <SnackbarProvider>
            <Router>
              <AuthProvider>
                <App />
              </AuthProvider>
            </Router>
          </SnackbarProvider>
        </ErrorBoundary>
      </LocalizationProvider>
    </AppThemeProvider>
  </GoogleReCaptchaProvider>
)
